<template>
  <div class="sales-contact-result" :class="`sales-contact-result--${type}`">
    <!-- result / contact person -->
    <Transition name="sales-contact-finder-slide-fade" mode="out-in" appear>
      <!-- when no contact person is available -->
      <template v-if="noResults">
        <div class="sales-contact-result__empty" :key="resultTransitionKey">
          <p v-html="noResultsText"></p>
        </div>
      </template>
      <!-- result / contact person -->
      <template v-else-if="!objectEmpty(result) && !noResults">
        <div class="sales-contact-result__content" :key="resultTransitionKey">
          <div class="sales-contact-result__image">
            <ResponsiveImage
              v-if="
                !objectEmpty(result) &&
                result.images &&
                result?.images.length > 0
              "
              :images="result.images || []" />
            <picture v-else class="responsive-image">
              <img
                :src="placeholderImage"
                :alt="t.placeholderImageAlt"
                class="responsive-image__img" />
            </picture>
          </div>

          <h3 v-html="result.name"></h3>
          <a v-if="result.email" :href="`mailto:${result.email}`">
            <span>{{ result.email }}</span>
          </a>
          <a
            v-if="result.phone && result.phone.length > 3"
            :href="`tel:${result.phone}`">
            <span>{{ result.phone }}</span>
          </a>

          <div
            v-if="(result.city_code || result.city) && type === 'finder'"
            class="sales-contact-result__location">
            <span v-if="result.city_code">{{ result.city_code }}</span>
            <span v-if="result.city">{{ result.city }}</span>
          </div>
        </div>
      </template>
    </Transition>
  </div>
</template>

<script>
// components
import ResponsiveImage from '../elements/ResponsiveImage';
// utils
import translationStrings from '../../translations/translationStrings';

export default {
  components: {
    ResponsiveImage,
  },
  props: {
    lang: {
      required: true,
      type: String,
    },
    type: {
      type: String,
      required: true,
    },
    result: {
      type: Object,
      default: () => {},
    },
    noResults: {
      type: Boolean,
      default: false,
    },
    noResultsText: {
      type: String,
      required: true,
    },
    transitionKey: {
      // just make it something that changes,
      // so that the transition triggers
      // even if the result is the same
      type: [Number, String],
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      t: translationStrings,
    };
  },
  computed: {
    placeholderImage() {
      return require('../../../images/placeholder-person.webp');
    },
    resultTransitionKey() {
      return this.transitionKey
        ? this.transitionKey
            .toString()
            .replace(/(^\s*(?!.+)\n+)|(\n+\s+(?!.+)$)/g, '')
        : `${new Date().getTime() / 1000}`;
    },
  },
  methods: {
    objectEmpty(obj) {
      return obj == null ? true : Object.keys(obj).length === 0;
    },
  },
};
</script>
